import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { OrganizationService } from '../models/organization-service';
import { Scope } from '../models/scope';
import { UserOrganization } from '../models/user-organization';

@Component({
  selector: 'app-organization-user',
  templateUrl: './organization-user.component.html',
  styleUrls: ['./organization-user.component.css']
})
export class OrganizationUserComponent implements OnInit {
  userOrganization: UserOrganization | null = null;
  organizationServices: OrganizationService[] | null = null;
  availableScopes: Scope[] = [];

  constructor(private api: ApiService, private route: ActivatedRoute, private authService: AuthService) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const orgId = params['orgId'];
      const userId = params['userId'];

      this.api.getOrganizationUser(orgId, userId).subscribe((data: UserOrganization) => {
        this.userOrganization = data;
      });

      if (this.authService.hasScope("iam:read:organization_service")) {
        this.api.getOrganizationServices(orgId).subscribe((data: OrganizationService[]) => {
          this.organizationServices = data;

          this.organizationServices.forEach((orgService: OrganizationService) => {
            this.availableScopes.push(...orgService.full_scopes);
          });

        });
      }
  });
  }

}
